import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'redux-react-hook';
import ReactDOM from 'react-dom';
import styled, { css } from 'styled-components';
import _includes from 'lodash/includes';
import _find from 'lodash/find';
import Endstate from 'styles/blocks/endstate/incomplete';
import { STRINGS } from 'config';
import { answerSingleChoice, addMultipleSelectAnswer } from 'redux/actions/consultation/answer';
import { goBack, getNextQuestion } from 'redux/actions/consultation';
import { clearSessionTimeout } from 'redux/actions/session';
import { Spinner } from 'styles/blocks/spinner';
import { Div } from 'styles/elements/div';
import { sendCancelUrgentEmergencyEventToGoogleAnalytics } from 'common/googleAnalytics';

const dotStyles = css`
  background-color: ${props => props.theme.buttonPrimaryBackgroundColor};
`;

const spinnerStyles = css`
  margin-left: 10px;
  animation-duration: 2s;
`;

const Spacer = styled(Div)`
  width: 39px;
`;

export function Incomplete({ question, isClinicalReviewMode, previous, responseType, isLoading, isForwardNavigation }) {
  // actions to update value
  const dispatch = useDispatch();
  const [isRedirecting, setIsRedirecting] = useState(false);
  const containerRef = useRef(null);
  useEffect(() => {
    if (containerRef !== null) {
      containerRef.current.scrollTop = 0;
    }
    if (_includes(responseType, 'ENDSTATE')) {
      dispatch(clearSessionTimeout());
    }
  }, [dispatch, responseType]);

  const button = document.querySelector('.consult-alert_button');

  useEffect(() => {
    if (button) {
      ReactDOM.render(
        <>
          <Spacer />
          <span>
            {button.innerText}
          </span>
          <Spinner isVisible={isRedirecting} />
        </>,
        button,
      );
      button.addEventListener('click', () => (button.target === '_blank' ? null : setIsRedirecting(true)));
    }
  }, [isRedirecting, button]);

  const confirmEndstate = async confirmAnswer => {
    if (isLoading) {
      return null;
    }
    if (question.type === STRINGS.QUESTION_TYPE.MULTIPLE || question.type === STRINGS.QUESTION_TYPE.ALLMULTIPLE) {
      await dispatch(addMultipleSelectAnswer(confirmAnswer));
      return dispatch(getNextQuestion());
    }
    return dispatch(answerSingleChoice(confirmAnswer));
  };

  const cancelEndstate = () => {
    const isUrgentAdvice = responseType === STRINGS.RESPONSE_TYPE.ADVICE_URGENT || responseType === STRINGS.RESPONSE_TYPE.ADVICE_URGENT_MH;
    const isEmergencyAdvice = responseType === STRINGS.RESPONSE_TYPE.ADVICE_EMERGENCY || responseType === STRINGS.RESPONSE_TYPE.ADVICE_EMERGENCY_MH;
    if (isUrgentAdvice || isEmergencyAdvice) {
      sendCancelUrgentEmergencyEventToGoogleAnalytics(isUrgentAdvice);
    }
    dispatch(goBack());
  };

  // todo: This doesn't seem like a good thing
  function createMarkup() {
    return { __html: question.text };
  }
  const confirm = _find(question.answers, answer => _includes(answer.answerId, 'CONFIRM'));
  return (
    <Endstate ie9Height={600} ref={containerRef}>
      <Endstate.Inner>
        <Endstate.ReceivedHTML dangerouslySetInnerHTML={createMarkup()} />
        <Endstate.ButtonsContainer>
          {confirm && (
            <Endstate.Confirm onClick={() => confirmEndstate(confirm)}>
              <Spacer />
              {confirm.text}
              {isClinicalReviewMode && <Endstate.ClinicalReviewIcon triageLevel={confirm.triageLevel} />}
              <Spinner isVisible={isLoading && isForwardNavigation} />
            </Endstate.Confirm>
          )}
          {previous && (
            <Endstate.Cancel onClick={() => cancelEndstate()}>
              Go back
              <Spinner isVisible={isLoading && !isForwardNavigation} spinnerStyles={spinnerStyles} dotStyles={dotStyles} />
            </Endstate.Cancel>
          )}
        </Endstate.ButtonsContainer>
      </Endstate.Inner>
    </Endstate>
  );
}
